import { BaseComponent } from '../../types';
import { MobileCard } from '../MobileCard/MobileCard';

interface MobileExperienceSectionProps extends BaseComponent {}

export function MobileExperienceSection({
  className,
}: MobileExperienceSectionProps) {
  return (
    <section
      className={`w-full relative ${className || ''}`}
      style={{
        minHeight: '821px',
        alignSelf: 'stretch',
        background: '#020816',
      }}
    >
      {/* Eyebrow - positioned at top left */}
      <div
        className="absolute top-8 left-8"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--item-spacing-12, 12px)',
          zIndex: 10,
        }}
      >
        <div
          style={{
            width: '40px',
            height: '1px',
            background: 'var(--color-azure-69, #76BCE8)',
          }}
        />
        <span
          style={{
            color: 'var(--Cornflower, var(--color-azure-78, #9DD0F0))',
            fontFamily: 'var(--font-family-Font-3, Inter)',
            fontSize: 'var(--font-size-11, 11px)',
            fontStyle: 'normal',
            fontWeight: 'var(--font-weight-600, 600)',
            lineHeight: 'normal',
            letterSpacing: 'var(--letter-spacing-3, 3px)',
            textTransform: 'uppercase',
          }}
        >
          Mobil DENEYİM
        </span>
      </div>

      {/* Content centered */}
      <div className="w-full h-full flex justify-center items-center px-4 lg:px-8 pt-24 pb-16 lg:py-0">
        <div
          className="lg:mt-[100px]"
          style={{
            display: 'flex',
            width: '954px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '20px',
          }}
        >
          <h2
            style={{
              color: '#FFF',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '48px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '50px',
              width: '100%',
            }}
          >
            Platformunuz{' '}
            <span
              style={{
                color: 'var(--Brand, #76BCE8)',
                fontFamily: 'Inter',
                fontSize: '48px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: '50px',
              }}
            >
              Cebinizde
            </span>
            : Her Yerden Erişim, Anında Aksiyon
          </h2>

          <p
            style={{
              color: 'rgba(255, 255, 255, 0.80)',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '18px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: 'normal',
              width: '100%',
            }}
          >
            CommerceMinder mobil uygulamaları ile satıcılar ve yöneticiler tüm
            operasyonel süreçlere her yerden erişebilir. Siparişler, bildirimler
            ve kritik süreçler mobilde anlık olarak takip edilebilir.
          </p>

          {/* Mobile Cards */}
          <div className="flex flex-col lg:flex-row gap-6 xl:gap-4 w-full justify-center mt-8 items-center lg:items-start">
            <MobileCard
              title="Anlık Bildirim & Hızlı Aksiyon"
              content="Yeni siparişler ve kritik durumlar için anında bildirim alın, mobil üzerinden hızlı aksiyonlar ile süreçleri kesintisiz ilerletin."
              showMockup={true}
            />
            <MobileCard
              title="Satıcı & Yönetici Mobil Deneyimi"
              content="Satıcılar sipariş ve ürün süreçlerini mobil cihazlarından takip edebilirken, yöneticiler tüm operasyonel akışı anlık olarak izleyebilir."
              showStorefrontMockup={true}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
